import React from 'react'
import { CCard, CCardBody, CBadge } from '@coreui/react-pro'

const CommunityTopTeamsModal = ({ item }) => {
  const { payload } = item

  if (!payload || !payload.teams || payload.teams.length === 0) {
    return <p>No team data available</p>
  }

  const getMedalEmoji = (rank) => {
    const medals = { 1: '🥇', 2: '🥈', 3: '🥉' }
    return medals[rank] || `#${rank}`
  }

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Top 5 Teams This in Round {payload?.round_number}</h5>
        <p style={{ marginBottom: '10px', color: '#666' }}>{payload.description}</p>
        <CBadge color="primary">TOP TEAMS</CBadge>
      </div>

      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {payload.teams.map((team, index) => (
          <CCard key={index} style={{ marginBottom: '12px' }}>
            <CCardBody style={{ padding: '12px' }}>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div>
                  <div style={{ marginBottom: '6px' }}>
                    <strong>
                      {getMedalEmoji(team.rank)} {team.team_name}
                    </strong>
                  </div>
                  <small style={{ color: '#666' }}>Points: {team.overall_points || 0} pts</small>
                </div>
                <CBadge color="secondary">Rank #{team.rank}</CBadge>
              </div>
            </CCardBody>
          </CCard>
        ))}
      </div>
    </div>
  )
}

export default CommunityTopTeamsModal
